var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelihoistLightL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 454,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1487,
    y: 1913,
    width: 452,
    height: 454
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1487 -1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1511 2140C1511 2027.89 1601.44 1937 1713 1937 1824.56 1937 1915 2027.89 1915 2140 1915 2252.11 1824.56 2343 1713 2343 1601.44 2343 1511 2252.11 1511 2140Z",
    stroke: "#000000",
    strokeWidth: 48.125,
    strokeMiterlimit: 8,
    fill: "#81F248",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelihoistLightL);
export default __webpack_public_path__ + "static/media/HelihoistLightL.cb31801afefc49b9c790c00f2bed19c9.svg";
export { ForwardRef as ReactComponent };